/**
 * 객체를 기반으로 `URLSearchParams` 인스턴스를 생성합니다.
 *
 * @param {object} params - 쿼리 파라미터의 키-값 쌍을 담은 객체.
 * @returns {URLSearchParams} 생성된 `URLSearchParams` 인스턴스.
 *
 * @example
 * const params = { search: "test", page: 1 };
 * const searchParams = makeSearchParams(params);
 * console.log(searchParams.toString());
 * 결과: "search=test&page=1"
 */
export const makeSearchParams = (params: any) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    searchParams.append(key, params[key]);
  });

  return searchParams;
};
